// VALMÉRA Mock Data - Fular & Eşarp Koleksiyonu

export const categories = [
  { id: 'all', name: 'Tümü', slug: 'tumu' },
  { id: 'foulards', name: 'Has İpek Fular', slug: 'has-ipek-fular' },
];

export const collections = [
  {
    id: 1,
    name: 'Kökten Işığa',
    slug: 'kokten-isiga',
    image: 'https://customer-assets-cm19k8pv.emergentagent.net/job_3f3acde8-bbff-4f28-a1ca-d72be186d0f6/artifacts/yre7q9yc_KI.png',
    description: 'Doğanın en saf halleri, ipek üzerinde hayat buluyor',
    available: true,
  },
  {
    id: 2,
    name: 'Türk Motifleri',
    slug: 'turk-motifleri',
    image: 'https://customer-assets-cm19k8pv.emergentagent.net/job_3f3acde8-bbff-4f28-a1ca-d72be186d0f6/artifacts/4m2lpdhc_TM%20Afis%CC%A76.png',
    description: 'Anadolu\'nun binlerce yıllık dokusu, modern ipeğe dokunuyor',
    available: true,
  },
  {
    id: 3,
    name: 'Yaz Masalı',
    slug: 'yaz-masali',
    image: null,
    description: 'Güneşin ipeğe düştüğü an — yakında',
    available: false,
  },
  {
    id: 4,
    name: 'Saklı Bahçe',
    slug: 'sakli-bahce',
    image: null,
    description: 'Yalnız sana açılan bir sır — yakında',
    available: false,
  },
  {
    id: 5,
    name: 'Göç',
    slug: 'goc',
    image: null,
    description: 'Bir yerden diğerine, bir kalpten diğerine — yakında',
    available: false,
  },
];

export const products = [
  {
    id: 1,
    name: 'Bereket Kuşağı Has İpek Fular',
    price: 2000,
    prices: { '65x65': 2000 },
    originalPrice: null,
    category: 'foulards',
    collection: 'kokten-isiga',
    image: 'https://customer-assets.emergentagent.com/job_silk-fular/artifacts/gfklpc2m_1.png',
    images: [
      'https://customer-assets.emergentagent.com/job_silk-fular/artifacts/gfklpc2m_1.png',
      'https://customer-assets.emergentagent.com/job_code-collaborator-8/artifacts/p4109dsy_Ads%C4%B1z%20tasar%C4%B1m.png',
      'https://customer-assets.emergentagent.com/job_code-collaborator-8/artifacts/ag192otp_Ads%C4%B1z%20tasar%C4%B1m%20%281%29.png',
      'https://customer-assets.emergentagent.com/job_code-collaborator-8/artifacts/asefkmez_Ads%C4%B1z%20tasar%C4%B1m%20%282%29.png',
    ],
    colors: ['Mor/Yeşil'],
    sizes: ['65x65'],
    stock: { '65x65': 9 },
    material: '%100 Has İpek',
    dimensions: '65x65 cm',
    description: 'Maden yasasıyla kesilen zeytinliklere bir başkaldırı; çerçeveden taşan ve üst üste binen zeytin dalları keskin renklerle doğanın direnişini anlatıyor.',
    features: ['Özel Tasarım', 'El Dikişi', 'Cilt Dostu İpek'],
    isNew: true,
    isBestseller: true,
    relatedProducts: [2, 3, 4],
    complementaryProducts: [5, 6],
  },
  {
    id: 2,
    name: 'Uzlaşı Tacı Has İpek Fular',
    price: 2000,
    prices: { '65x65': 2000 },
    originalPrice: null,
    category: 'foulards',
    collection: 'kokten-isiga',
    image: 'https://customer-assets.emergentagent.com/job_silk-fular/artifacts/6ixx3mxa_2.png',
    images: [
      'https://customer-assets.emergentagent.com/job_silk-fular/artifacts/6ixx3mxa_2.png',
      'https://customer-assets.emergentagent.com/job_code-collaborator-8/artifacts/jg6xip77_Ads%C4%B1z%20tasar%C4%B1m%20%283%29.png',
    ],
    colors: ['Mor/Sarı/Yeşil'],
    sizes: ['65x65'],
    stock: { '65x65': 9 },
    material: '%100 Has İpek',
    dimensions: '65x65 cm',
    description: 'Doğanın direnişinden doğan bir denge... Zeytinler artık bir düzene kavuşur; ancak çerçeveyi saran zıt uyumlu canlı renkler, hâla umudun ve başkaldırının ritmini taşır.',
    features: ['Özel Tasarım', 'El Dikişi', 'Cilt Dostu İpek'],
    isNew: true,
    isBestseller: false,
    relatedProducts: [1, 3, 5],
    complementaryProducts: [4, 7],
  },
  {
    id: 3,
    name: 'Zeytin Dalı Has İpek Fular',
    altName: 'Zeytin Dalı Has İpek Fular&Eşarp',
    price: 2000,
    prices: { '65x65': 2000, '90x90': 2850 },
    originalPrice: null,
    category: 'foulards',
    collection: 'kokten-isiga',
    image: 'https://customer-assets.emergentagent.com/job_silk-fular/artifacts/xwjgu3rm_3.png',
    images: [
      'https://customer-assets.emergentagent.com/job_silk-fular/artifacts/xwjgu3rm_3.png',
    ],
    colors: ['Gri/Yeşil/Sarı'],
    sizes: ['65x65', '90x90'],
    stock: { '65x65': 9, '90x90': 9 },
    material: '%100 Has İpek',
    dimensions: '65x65 cm',
    description: 'Direnişin ardından gelen sessizlik… Renkler ve dallar bu kez bir dengeye varır; doğa nefes alır, barış kendi içinde filizlenir.',
    features: ['Özel Tasarım', 'El Dikişi', 'Cilt Dostu İpek'],
    isNew: true,
    isBestseller: true,
    relatedProducts: [1, 4, 5],
    complementaryProducts: [2, 6],
  },
  {
    id: 4,
    name: 'Filiz Dinçmen – "Diplomasinin Zeytin Tacı" Has İpek Fular',
    altName: 'Filiz Dinçmen – "Diplomasinin Zeytin Tacı" Has İpek Fular&Eşarp',
    price: 2000,
    prices: { '65x65': 2000, '75x75': 2500 },
    originalPrice: null,
    category: 'foulards',
    collection: 'kokten-isiga',
    image: 'https://customer-assets.emergentagent.com/job_silk-fular/artifacts/v4v9kxl5_6.png',
    images: [
      'https://customer-assets.emergentagent.com/job_silk-fular/artifacts/v4v9kxl5_6.png',
    ],
    colors: ['Sarı/Lacivert'],
    sizes: ['65x65', '75x75'],
    stock: { '65x65': 9, '75x75': 9 },
    material: '%100 Has İpek',
    dimensions: '65x65 cm',
    description: 'Portreyi çevreleyen zeytin dalları, barış ve uzlaşının sembolüdür. Altın detaylar zarafeti, lacivert bant itibar ve kararlılığı anlatır. Tasarım, Filiz Dinçmen\'in diplomasiye açtığı yolu ve kadınların saygın duruşunu temsil eder.',
    features: ['Özel Tasarım', 'El Dikişi', 'Cilt Dostu İpek'],
    isNew: true,
    isBestseller: true,
    relatedProducts: [1, 5, 7],
    complementaryProducts: [2, 3],
  },
  {
    id: 5,
    name: 'Safiye Ali – "Umut Halesi" Has İpek Fular',
    altName: 'Safiye Ali – "Umut Halesi" Has İpek Fular&Eşarp',
    price: 2000,
    prices: { '65x65': 2000, '75x75': 2500 },
    originalPrice: null,
    category: 'foulards',
    collection: 'kokten-isiga',
    image: 'https://customer-assets.emergentagent.com/job_silk-fular/artifacts/7384beou_7.png',
    images: [
      'https://customer-assets.emergentagent.com/job_silk-fular/artifacts/7384beou_7.png',
    ],
    colors: ['Pembe/Yeşil'],
    sizes: ['65x65', '75x75'],
    stock: { '65x65': 9, '75x75': 9 },
    material: '%100 Has İpek',
    dimensions: '65x65 cm',
    description: 'Kadın silüetleri zarafeti ve kararlılığı simgeler. Zeytin dalları barışı, yeşil tonlar umudu, pembe tonlar şefkati anlatır. Tasarım, Safiye Ali\'nin bilimle, cesaretle ve kadınlar için açtığı yoldan hâlâ ışık alıyor.',
    features: ['Özel Tasarım', 'El Dikişi', 'Cilt Dostu İpek'],
    isNew: true,
    isBestseller: false,
    relatedProducts: [3, 4, 2],
    complementaryProducts: [1, 6],
  },
  {
    id: 6,
    name: 'Hâlide Edip Adıvar – "Sözün Halkası" Has İpek Fular',
    altName: 'Hâlide Edip Adıvar – "Sözün Halkası" Has İpek Fular&Eşarp',
    price: 2000,
    prices: { '65x65': 2000, '75x75': 2500, '90x90': 2850 },
    originalPrice: null,
    category: 'foulards',
    collection: 'kokten-isiga',
    image: 'https://customer-assets.emergentagent.com/job_silk-fular/artifacts/k3ryxhlq_4.1.png',
    images: [
      'https://customer-assets.emergentagent.com/job_silk-fular/artifacts/k3ryxhlq_4.1.png',
    ],
    colors: ['Mor/Yeşil'],
    sizes: ['65x65', '75x75', '90x90'],
    stock: { '65x65': 9, '75x75': 9, '90x90': 9 },
    material: '%100 Has İpek',
    dimensions: '65x65 cm',
    description: 'Kadının doğayla kurduğu bağ, köklerinden gelen direncini ve özün dönüştürücü gücünü simgeler. Zeytin halkasındaki mor ve yeşil tonlar, yaşamın döngüsünü ve kadının içsel gücünü yansıtır. Hâlide Edip\'in silueti, bilgelik ve direnişin sembolü olarak bu halkada yerini alır.',
    features: ['Özel Tasarım', 'El Dikişi', 'Cilt Dostu İpek'],
    isNew: false,
    isBestseller: true,
    relatedProducts: [1, 3, 5],
    complementaryProducts: [4, 7],
  },
  {
    id: 7,
    name: 'Afife Jale – "Perdenin İlk Adımı" Has İpek Fular',
    altName: 'Afife Jale – "Perdenin İlk Adımı" Has İpek Fular&Eşarp',
    price: 2000,
    prices: { '65x65': 2000, '90x90': 2850 },
    originalPrice: null,
    category: 'foulards',
    collection: 'kokten-isiga',
    image: 'https://customer-assets.emergentagent.com/job_silk-fular/artifacts/1jho6j3r_5.png',
    images: [
      'https://customer-assets.emergentagent.com/job_silk-fular/artifacts/1jho6j3r_5.png',
    ],
    colors: ['Yeşil/Gold'],
    sizes: ['65x65', '90x90'],
    stock: { '65x65': 9, '90x90': 9 },
    material: '%100 Has İpek',
    dimensions: '65x65 cm',
    description: 'Kadın yüzü, sahneye ilk adımın cesaretini simgeler. Zeytin dalları ve çiçekler, açılan perdeyle doğan özgürlüğü anlatır. Afife Jale\'nin sahneye çıkışıyla başlayan kadın görünürlüğüne bir göndermedir.',
    features: ['Özel Tasarım', 'El Dikişi', 'Cilt Dostu İpek'],
    isNew: false,
    isBestseller: false,
    relatedProducts: [2, 3, 6],
    complementaryProducts: [1, 4],
  },
];

// Video for hero section
export const heroVideo = '/api/uploads/hero_video.mp4';

export const heroSlides = [
  {
    id: 1,
    title: 'Kökten Işığa',
    subtitle: 'Yeni Koleksiyon',
    description: 'Doğanın en saf halleri, ipek üzerinde hayat buluyor',
    image: 'https://customer-assets.emergentagent.com/job_silk-fular/artifacts/k3ryxhlq_4.1.png',
    buttonText: 'Koleksiyonu Keşfet',
    link: '/urunler',
    isVideo: false,
  },
];

export const testimonials = [
  {
    id: 1,
    name: 'Ayşe Yılmaz',
    role: 'Moda Editörü',
    text: 'VALMÉRA eşarpları gerçek bir sanat eseri. Kalitesi ve tasarımları rakipsiz.',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&q=80',
  },
  {
    id: 2,
    name: 'Elif Demir',
    role: 'İş Kadını',
    text: 'Her önemli toplantıma VALMÉRA ile gidiyorum. Kendimi güçlü ve şık hissediyorum.',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&q=80',
  },
  {
    id: 3,
    name: 'Zeynep Kaya',
    role: 'Stil Danışmanı',
    text: 'Müşterilerime her zaman VALMÉRA öneriyorum. Mükemmel işçilik.',
    avatar: 'https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?w=100&q=80',
  },
];

export const navLinks = [
  { name: 'Ana Sayfa', path: '/' },
  { name: 'Koleksiyonlar', path: '/koleksiyonlar' },
  { name: 'Ürünler', path: '/urunler' },
  { name: 'Blog', path: '/blog' },
  { name: 'Hakkımızda', path: '/hakkimizda' },
  { name: 'İletişim', path: '/iletisim' },
];

export const footerLinks = {
  shop: [
    { name: 'Has İpek Fular', path: '/urunler?category=foulards' },
    { name: 'Kökten Işığa Koleksiyonu', path: '/urunler' },
    { name: 'Tüm Ürünler', path: '/urunler' },
  ],
  company: [
    { name: 'Hakkımızda', path: '/hakkimizda' },
  ],
  support: [
    { name: 'İletişim', path: '/iletisim' },
    { name: 'Kargo & İade', path: '/kargo-iade' },
    { name: 'Sıkça Sorulan Sorular', path: '/sss' },
    { name: 'Bakım Önerileri', path: '/bakim' },
  ],
};
